<script setup lang="ts">
import type { CustomerBrand } from '@shared/config'

import { AppBadge, BadgeCustomerBrand } from '@shared/ui/badges'
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'DisciplineGeneralTitle',
})

defineProps<{
  title: string
  isGo: boolean
  brand: CustomerBrand | null
}>()
</script>

<template>
  <div class="discipline-general-title">
    <AppText name="h3">
      {{ title }}
    </AppText>
    <AppBadge
      v-if="isGo"
      color="emerald"
      text="Goal"
      title="GO lead"
    />
    <BadgeCustomerBrand
      :brand="brand"
      view="icon"
    />
  </div>
</template>

<style scoped lang="scss" src="./DisciplineGeneralTitle.scss" />
